import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Appointment from '../sections/Appointment/Appointment';
import Emergency from '../sections/Emergency/Emergency';
import Footer from '../sections/Footer/Footer';
import Services from '../sections/Services/Services';
import TeamHeader from '../sections/TeamHeader/TeamHeader';
import ContactForm from '../components/ContactForm/ContactForm';
import SectionTitle from '../components/SectionTitle/SectionTitle';
import SEO from '../components/SEO/SEO';
import { getDentistSchema } from '../components/SEO/schema';
import { useTranslation } from 'react-i18next';

const Home = () => {
    const { t } = useTranslation();

    return (
        <>
            <SEO
                title="Zahnarzt Tönisvorst | Zahnarztpraxis Roman Boretskyi"
                description="Ihr Zahnarzt in Tönisvorst: moderne Zahnmedizin von Prophylaxe bis Implantate, mit Kassenzulassung. Jetzt online einen Termin vereinbaren."
                path="/"
                jsonLd={getDentistSchema()}
            />
            <Navbar/>
            <TeamHeader/>
            <Services/>
            <Emergency/>
            <Appointment/>
            
            <section className='section-bg section-common contact-form-section pt-100 pb-70' data-aos="fade-up">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <SectionTitle 
                                title={t('contactForm.sectionTitle') || 'Kontaktieren Sie uns'}
                                subTitle={t('contactForm.sectionSubTitle') || 'KONTAKT'}
                                description={t('contactForm.sectionDescription') || 'Füllen Sie das Formular aus und wir melden uns schnellstmöglich bei Ihnen.'}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </section>
            
            <Footer/>
        </>
    );
};

export default Home;